import { ia } from 'lib/helpers/utility';

export const getSubmenuId = (submenuKey) => `popover-submenu-${submenuKey}`;

/**
 * ARIA attributes for an option that opens a submenu; empty for leaf options.
 * Keyboard support lives in `lib/menuKeyboard` (ArrowRight/Enter/Space open, ArrowLeft returns).
 */
export const getSubmenuAriaProps = ({ option, isHovered, submenuKey }) => {
  if (!ia(option?.children)) return {};
  return {
    'aria-haspopup': 'menu',
    'aria-expanded': isHovered,
    'aria-controls': isHovered ? getSubmenuId(submenuKey) : undefined
  };
};
